// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ImageTooltip_wrapper__r4grc","tooltipTarget":"ImageTooltip_tooltipTarget__fQKJz"};